import firebase from "firebaseConfig"

const logoutAction = () => async (dispatch) => {
  firebase
    .auth()
    .signOut()
    .then(() => {
      console.log("User Logged Out.")
      dispatch({ type: "logout", payload: false })
      // window.location.replace('/');
    })
    .catch((err) => {
      console.log(`Error Logging Out User. Error:\n${err}`)
      alert(err)
    })
}

export default logoutAction
